import {
  findByIdWithSchema,
  GenericContentSchema,
  GenericGroupSchema,
  type GenericContent,
  type GenericGroup,
  type GenericSection,
} from '../../../../../brand/lib/types/contentful'
import {getPlanItems, type PlanItem} from '../../content-plan-items'

export type HeroSectionContent = {
  hero?: GenericContent
  ideList?: GenericContent
  planItems: PlanItem[]
  planTypes?: GenericContent
  pricingOptions?: GenericGroup
}

export function toHeroSectionContent(section: GenericSection): HeroSectionContent {
  const hero = findByIdWithSchema(section.fields.content, 'featuresCopilotPlansHero', GenericContentSchema)
  const ideList = findByIdWithSchema(section.fields.content, 'featuresCopilotPlansHeroIdeList', GenericContentSchema)
  const planTypes = findByIdWithSchema(section.fields.content, 'featuresCopilotPlanTypes', GenericContentSchema)
  const pricingOptions = findByIdWithSchema(section.fields.content, 'featuresCopilotPricingOptions', GenericGroupSchema)
  const planItems = getPlanItems(planTypes)

  return {hero, ideList, planItems, planTypes, pricingOptions}
}
